export default __webpack_public_path__ + "static/pocket-gems-c1aaecb4f88cf9710e6d5d2c2b50c8c5.svg";